/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Group_Cannot_ManageInputs */

const en_us2_plan_group_cannot_manage = /** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This group cannot build this person's plan.`)
};

const pt_br2_plan_group_cannot_manage = /** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta turma não pode montar o plano dessa pessoa.`)
};

const pt_pt2_plan_group_cannot_manage = /** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta turma não pode montar o plano dessa pessoa.`)
};

/** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */
const es_419_plan_group_cannot_manage = en_us2_plan_group_cannot_manage;

/** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */
const fr_fr2_plan_group_cannot_manage = en_us2_plan_group_cannot_manage;

/** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */
const de_de2_plan_group_cannot_manage = en_us2_plan_group_cannot_manage;

/** @type {(inputs: Plan_Group_Cannot_ManageInputs) => LocalizedString} */
const it_it2_plan_group_cannot_manage = en_us2_plan_group_cannot_manage;

/**
* | output |
* | --- |
* | "This group cannot build this person's plan." |
*
* @param {Plan_Group_Cannot_ManageInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_group_cannot_manage = /** @type {((inputs?: Plan_Group_Cannot_ManageInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Group_Cannot_ManageInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_group_cannot_manage(inputs)
	if (locale === "es-419") return es_419_plan_group_cannot_manage(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_group_cannot_manage(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_group_cannot_manage(inputs)
	if (locale === "de-DE") return de_de2_plan_group_cannot_manage(inputs)
	if (locale === "it-IT") return it_it2_plan_group_cannot_manage(inputs)
	return en_us2_plan_group_cannot_manage(inputs)
});
export { plan_group_cannot_manage as "plan.group_cannot_manage" }